interface StatsRowProps {
  stats: {
    totalStories: number;
    totalReads: number;
    totalLikes: number;
    followers: number;
  };
}

export default function StatsRow({ stats }: StatsRowProps) {
  const formatNumber = (num: number) => {
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1) + 'M';
    }
    if (num >= 1000) {
      return (num / 1000).toFixed(1) + 'K';
    }
    return num.toString();
  };

  const statItems = [
    {
      icon: 'ri-book-2-line',
      label: 'Stories',
      value: stats.totalStories
    },
    {
      icon: 'ri-eye-line',
      label: 'Total Reads',
      value: formatNumber(stats.totalReads)
    },
    {
      icon: 'ri-heart-line',
      label: 'Total Likes',
      value: formatNumber(stats.totalLikes)
    },
    {
      icon: 'ri-user-follow-line',
      label: 'Followers',
      value: formatNumber(stats.followers)
    }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-8">
      {statItems.map((stat, index) => (
        <div
          key={index}
          className="bg-zinc-900 border border-red-900/30 rounded-lg p-6 text-center hover:border-red-900/50 transition-all duration-300"
        >
          <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3">
            <i className={`${stat.icon} text-3xl text-red-500`}></i>
          </div>
          <div className="text-3xl font-bold text-zinc-100 mb-1" style={{ fontFamily: 'Cinzel, serif' }}>
            {stat.value}
          </div>
          <div className="text-sm text-zinc-400" style={{ fontFamily: 'Crimson Text, serif' }}>
            {stat.label}
          </div>
        </div>
      ))}
    </div>
  );
}